import { redirect } from "@tanstack/react-router";
import { useLoginStore } from "features/login/store";
import { filterEmpresasComAcessoLacto, getTokenStatus, hasAcessoSistemaPersonalizado, userHasPermission } from "features/login/util";
import type { Permissao, TipoPermissao } from "features/usuario/types/ApiUsuarioTipoPermissao";

export function validateRoute({
	permissao,
	nivel,
	condicao,
}: {
	permissao?: Permissao;
	nivel?: TipoPermissao.Completo | TipoPermissao.Parcial;
	condicao?: boolean;
}) {
	if (condicao === false) {
		throw redirect({
			to: "/",
		});
	}

	if (permissao && nivel && !userHasPermission(permissao, nivel)) {
		throw redirect({
			to: "/",
		});
	}
}

// Validações se o usuário está logado
export function goToLogin(): boolean {
	const { login, empresaIdpk } = useLoginStore.getState();
	const isUserLogged = login !== undefined && empresaIdpk !== undefined;
	const isAuth = location.pathname.startsWith("/auth/");

	// Se não estiver logado, mas estiver numa tela de autenticação não fazer nada
	if (!isUserLogged && isAuth) {
		return false;
	}

	// Se não estiver logado manda pro login
	if (!isUserLogged) {
		return true;
	}

	const empresasPermitidas = filterEmpresasComAcessoLacto(login.usuario_empresa);

	// Sessão antiga / sem permissão de acesso ao Lacto
	if (empresasPermitidas.length === 0) {
		useLoginStore.getState().clearLogin();
		return !isAuth;
	}

	if (empresasPermitidas.length !== login.usuario_empresa.length) {
		useLoginStore.setState({
			login: {
				...login,
				usuario_empresa: empresasPermitidas,
			},
		});
	}

	const empresaAtualPermitida = empresasPermitidas.some((empresa) => empresa.use_empresa_idpk === empresaIdpk);

	if (!empresaAtualPermitida || !hasAcessoSistemaPersonalizado(useLoginStore.getState().getUsuarioEmpresa())) {
		useLoginStore.getState().clearLogin();
		return !isAuth;
	}

	const tokenStatus = getTokenStatus();

	// Se o token estiver expirado, envia pro login caso não estiver numa tela auth
	if (tokenStatus === "expired") {
		return !isAuth;
	}

	// Se token estiver prestes a expirar, realizar renovação
	if (tokenStatus === "about-to-expire") {
		useLoginStore.getState().renovarToken();
	}

	return false;
}
